import { Component } from "@angular/core";
import { PracticeRegionFilter } from "src/app/model/practice-region-filter";
import { MedicalOrderService } from "src/app/services/medical-order.service";

@Component({
  selector: "app-test-clayer-ml",
  templateUrl: "./test-clayer-ml.component.html",
})
export class TestClayerMlComponent {
  selectedFile: File | null = null;
  uploadStatus: string = "";
  extractedProcedures: any[] = [];
  isDragging: boolean = false;

  constructor(private medicalOrderService: MedicalOrderService) {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.uploadStatus = "";
      this.extractedProcedures = [];
      this.onSubmit();
    }
  }

  async onSubmit(): Promise<void> {
    if (!this.selectedFile) {
      this.uploadStatus = "No file selected.";
      return;
    }

    this.uploadStatus = "Procesando...";

    try {
      const base64 = await this.convertFileToBase64(this.selectedFile);
      const result = await this.medicalOrderService.extractProcedures(base64, 0);
      this.extractedProcedures = [];
      this.uploadStatus = "Prácticas extraídas correctamente.";
    } catch (error) {
      console.error(error);
      this.uploadStatus = "Error al extraer las prácticas.";
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
    if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      this.selectedFile = event.dataTransfer.files[0];
    }
  }

  getRecognizedProceduresText(): string {
    const recognized = this.extractedProcedures.filter(
      (procedure) => procedure.PracticeRegion
    ).length;

    return `${recognized} de ${this.extractedProcedures.length}`;


  }

  private convertFileToBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        resolve(result);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }
}
